import { Flex, Skeleton, Space, Text } from '@mantine/core';
import { QuestionnaireItem } from './QuestionnaireItem';
import { BmsSampleVoucherItem } from './BmsSampleVoucherItem';
import { useVoucherStateStore } from '../stores/VoucherStateStore';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { EmptyPlaceholder } from './EmptyPlaceholder';
import { VoucherAllowanceStatus } from '@web/common';

export const OpenQuestionnaires = observer(() => {
  const store = useVoucherStateStore();
  const { t } = useTranslation('questionnaire');

  const notFilledOut = store.voucherStates?.filter(
    (item) => !item.questionnaireCompleted,
  );
  const hasBmsSampleAvailable =
    store.bmsSampleVoucherStatus?.type ===
    VoucherAllowanceStatus.AvailableToBeRedeemed;
  const hasItems =
    (notFilledOut && notFilledOut.length > 0) || hasBmsSampleAvailable;

  return (
    <Flex flex="1" direction="column" gap="4px">
      <Text fw="600" size="21px" lh="24px">
        {t('Wrapper.OpenQuestionnaires')}
      </Text>

      <Text size="16px" lh="24px" c="#4A4A48">
        {t('Wrapper.OpenQuestionnairesSubtitle')}
      </Text>

      <Skeleton visible={store.loading}>
        {!hasItems ? (
          <EmptyPlaceholder forOpen={true} />
        ) : (
          <>
            <Space h="10px" />
            <Flex gap="10px" direction="column">
              {hasBmsSampleAvailable && <BmsSampleVoucherItem />}
              {notFilledOut?.map((item) => (
                <div
                  key={item.surveyLinkId}
                  onClick={() => window.open(item.questionnaireLink, '_blank')}
                >
                  <QuestionnaireItem
                    key={item.surveyLinkId}
                    questionnaire={item}
                  />
                </div>
              ))}
            </Flex>
          </>
        )}
      </Skeleton>
    </Flex>
  );
});
